import { defineComponent as r, openBlock as a, createBlock as l, unref as c, mergeProps as p, withCtx as v, createElementVNode as o } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ r({
  name: "IconLockUnlocked",
  __name: "IconLockUnlocked",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (m, e) => (a(), l(c(d), p(t, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        o("path", { d: "M10.25 12.75A.75.75 0 0 1 11 13.5v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M14.5 6.7c0-1.291 1.166-2.45 2.75-2.45S20 5.409 20 6.7v1.8a.75.75 0 0 0 1.5 0V6.7c0-2.243-1.968-3.95-4.25-3.95S13 4.457 13 6.7v2.05H5.75A3.25 3.25 0 0 0 2.5 12v6a3.25 3.25 0 0 0 3.25 3.25h9A3.25 3.25 0 0 0 18 18v-6a3.25 3.25 0 0 0-3.25-3.25H14.5V6.7m-8.75 3.55A1.75 1.75 0 0 0 4 12v6a1.75 1.75 0 0 0 1.75 1.75h9A1.75 1.75 0 0 0 16.5 18v-6a1.75 1.75 0 0 0-1.75-1.75h-9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
